<template>
  <v-container v-if="$can('sensitive-data')" fluid>
    <v-toolbar>
      <v-toolbar-title>{{ $t('DEVICES.ITEMS') }}</v-toolbar-title>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <devices-list-filter @setRequest="setFilters" />

      <devices-list
        :meta="meta"
        :devices="devices"
        :options.sync="options"
        :type="$options.DEVICE"
        @show="show"
      />
    </v-sheet>

    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      width="unset"
      max-width="600"
    >
      <component
        :is="component.name"
        v-bind="component.data"
        @created="cancelDialogAndRefresh"
        @updated="cancelDialogAndRefresh"
        @cancel="cancelDialog"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import DevicesList, { DEVICE } from '../../components/DeviceList.vue';
import DevicesListFilter from '../components/DevicesListFilter.vue';
import DataOptions from '@/modules/_global/classes/DataOptions';
import { DevicesService } from '@/services/devices.service';

export default {
  name: 'DevicesPage',

  DEVICE,

  components: {
    DevicesList,
    DevicesListFilter,
    EditDevice: () =>
      import('@/modules/devices/Device/components/EditDevice.vue')
  },

  data() {
    return {
      meta: {},
      devices: [],
      filters: {},
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['id'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      dialog: false,
      component: null
    };
  },

  computed: {
    preparedOptions() {
      return DataOptions.createFromObject(this.options).toBackendFormat();
    },

    params() {
      return Object.assign({}, this.filters, this.preparedOptions);
    }
  },

  watch: {
    options: {
      deep: true,
      immediate: true,
      handler() {
        this.refreshData();
      }
    },
    filters: {
      deep: true,
      handler() {
        this.options.page = 1;
        this.refreshData();
      }
    }
  },

  methods: {
    refreshData() {
      DevicesService.getList(this.params).then(({ data }) => {
        this.devices = data.data;
        this.meta = data.meta;
      });
    },

    setFilters(filters) {
      this.filters = filters;
    },

    show(device) {
      this.dialog = true;
      this.component = {
        name: 'EditDevice',
        data: {
          id: device.id,
          showDeviceDetails: true,
          showCustomerDetails: true
        }
      };
    },

    cancelDialog() {
      this.dialog = false;
      this.component = null;
    },

    cancelDialogAndRefresh() {
      this.refreshData();
      this.cancelDialog();
    }
  }
};
</script>

<style scoped></style>
